import * as React from "react";
import { inject, observer } from "mobx-react";
import Page from "@templates/page";


@inject("store")
@observer
export default class Startpage extends React.Component {
    constructor(props) {
        super(props);
    }


    render() {
        return (
            <Page {...this.props}/>
        );
    }
}

